import { Container, Grid } from '@mui/material'
import React from 'react'
import { P, SectionWrapper } from '../../../Styles/style'
import twitter from "../../../../assets/images/wtwitter.png"
import telegram from "../../../../assets/images/wtelegram.png"
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

const SocialImg = styled.img`
    width:100%;
    height:auto;
    max-width:31px;
    margin:0 10px;
`
const BuyNow = styled.a`
text-decoration: none;

`
const Section9_Footer = () => {
    const theme = useTheme()
    return (
        <>
            <SectionWrapper p="3.5rem 0" id="contact" bgColor={theme.textTertiary} align="center">
                <Container maxWidth="xl">
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={11} lg={10} xl={8.4}>

                            <P p="20px 0" m="0" align="center" data-aos="flip-up"
                                data-aos-easing="ease-in"
                                data-aos-delay="400"
                                data-aos-duration="400"
                                data-aos-offset="0">
                                Disclaimer:
                                <br />
                                Investing in cryptocurrencies involves risks, including the potential loss of your investment. The value of
                                cryptocurrencies can be highly volatile, and market conditions can change rapidly. We recommend
                                conducting thorough research and consulting with financial professionals before making any investment
                                decisions. However, with risk comes opportunity, and by embracing the potential of cryptocurrencies like Floki
                                on the Pulse Network, you can seize exciting possibilities and embrace the future of decentralized finance.
                            </P>
                            <BuyNow href="https://t.me/flokicoinpulse" target="blank" data-aos="zoom-in-up"
                                data-aos-easing="ease-in"
                                data-aos-delay="800"
                                data-aos-duration="500"
                                data-aos-offset="0">
                                <SocialImg loading="lazy" src={telegram} />
                            </BuyNow>
                            <BuyNow href="https://twitter.com/FlokicoinPulse" target="blank" data-aos="zoom-in-up"
                                data-aos-easing="ease-in"
                                data-aos-delay="900"
                                data-aos-duration="500"
                                data-aos-offset="0"> <SocialImg loading="lazy" src={twitter} />
                            </BuyNow>
                            <P p="60px 0 0" m="0" align="center" data-aos="flip-up"
                                data-aos-easing="ease-in"
                                data-aos-delay="400"
                                data-aos-duration="400"
                                data-aos-offset="0">  © 2023 Floki on the Pulse Network. All rights reserved.
                            </P>
                        </Grid>
                    </Grid>
                </Container>
            </SectionWrapper>
        </>
    )
}

export default Section9_Footer